import { FC, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import useOtbFollowUp from '@hook/Otb/use-followUp'
import useTable from '@hook/shared/use-table'

import { removeCurrencyMask } from '@helper/removeCurrentyMask'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

interface ITableGridHeader {
  selected?: any
  isModal?: boolean
  isAction?: boolean
  updateIsModalConfig?: () => void
}

const TableGridFooter: FC<ITableGridHeader> = ({ isAction = false }) => {
  const { pathname } = useLocation()
  const { columns, dataFooter } = useTable()
  const { setGraphicValues, setIsShowContentChart, setIsGraphic } =
    useOtbFollowUp()

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: dataFooter[0][row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: dataFooter[0][column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }

    return res
  }, [columns, dataFooter])

  useEffect(() => {
    if (pathname === '/otb/acompanhamento') {
      setGraphicValues({
        desvioMedio: [
          {
            data: 'ESTQ INICIAL',
            valor: removeCurrencyMask(
              rows.filter(item => item.id === 'indicador-estoque-inicial')
                .length > 0
                ? rows.filter(
                    item => item.id === 'indicador-estoque-inicial'
                  )[0].value
                : 0
            )
          },
          {
            data: 'ESTQ ATUAL',
            valor: removeCurrencyMask(
              rows.filter(item => item.id === 'indicador-estoque-atual')
                .length > 0
                ? rows.filter(item => item.id === 'indicador-estoque-atual')[0]
                    .value
                : 0
            )
          },
          // {
          //   data: 'RECEBIDO MÊS',
          //   valor: removeCurrencyMask(
          //     rows.filter(item => item.id === 'indicador-rec-mes')[0].value
          //   )
          // },
          {
            data: 'VD REAL',
            valor: removeCurrencyMask(
              rows.filter(item => item.id === 'indicador-vd-real')[0].value
            )
          },
          // {
          //   data: 'A RECEBER',
          //   valor: removeCurrencyMask(
          //     rows.filter(item => item.id === 'indicador-areceber')[0].value
          //   )
          // },
          {
            data: 'VD PROJ',
            valor: removeCurrencyMask(
              rows.filter(item => item.id === 'indicador-vd-planej-pcl')[0]
                .value
            )
          },
          // {
          //   data: 'OTB',
          //   valor: removeCurrencyMask(
          //     rows.filter(item => item.id === 'indicador-open-to-by')[0].value
          //   )
          // },
          {
            data: 'ESTQ PROJ',
            valor: removeCurrencyMask(
              rows.filter(item => item.id === 'indicador-vd-planej-proj')[0]
                .value
            )
          },
          {
            data: 'QTD RECEBER',
            valor: removeCurrencyMask(
              rows.filter(
                item => item.id === 'indicador-estoque-final-ajust'
              )[0].value
            )
          }
        ]
      })

      setIsShowContentChart(true)
      setIsGraphic(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <tfoot>
      <tr>
        {isAction && (
          <th
            id="action-column"
            style={{
              background: '#EDF2F7',
              position: 'sticky',
              bottom: 0
            }}
            scope="col"
          ></th>
        )}

        {rows!.map(({ id, value, align }) => (
          <th
            style={{
              background: '#EDF2F7',
              position: 'sticky',
              bottom: 0
            }}
            key={`${id}-header`}
            align={align || 'left'}
            scope="col"
          >
            <span
              style={{
                fontSize: 14,
                fontWeight: 600
              }}
            >
              {value}
            </span>
          </th>
        ))}
      </tr>
    </tfoot>
  )
}

export default TableGridFooter
